export default __webpack_public_path__ + "static/media/ic_close_circle.a89f1858.svg";